import React from 'react';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import PackageItemBlockData from 'Models/Content/PackageItemBlockData';
import MarketingTextBlockData from 'Models/Content/MarketingTextBlockData';
import Arrow from 'app/Components/Shared/Arrow';
import CircularBadge from 'app/Components/Shared/CircularBadge';
import StripBadge from 'app/Components/Shared/StripBadge';
import Timer from './Timer';
import IconBlockData from 'Models/Content/IconBlockData';
import {getImageProps, getBackgroundImageProps} from 'app/utilities/ImageProps';
import {gaEvent} from 'app/utilities/analytics/tracking';
import gaParams from 'app/utilities/analytics/constants';
import TagName from 'app/Components/Shared/TagName';
import Image from 'app/Components/Shared/Image/image';
const PackageItemBlock = ({data, context}: ComponentProps<PackageItemBlockData>) => {
  if (data.expireDate.value && new Date() > new Date(data.expireDate.value)) return null;

  const checkIfComma = (price: string) => {
    if (price.includes('.')) {
      const indexOfComma = price.indexOf('.');
      return (
        <>
          {price.slice(0, indexOfComma)} <span className='small-digit'>{price.slice(indexOfComma + 1)}.</span>
        </>
      );
    } else {
      return <>{price}</>;
    }
  };

  const onLink = () => {
    const category = gaParams.GENERAL_NEW_SALE_ACTION_CLICK.category;
    const eventType = gaParams.GENERAL_NEW_SALE_ACTION_CLICK.eventType;
    const eventParams = data.title.value;
    gaEvent(category, eventType, eventParams);
  };

  return (
    <div className='PackageItemBlock' {...getBackgroundImageProps(data.backgroundImage, context)}>
      <a href={data.buttonLink?.value} onClick={onLink} onKeyPress={(e) => e.key == 'Enter' && onLink()}>
        <div className={`PackageItemBlock__details ${data.expireDate.value && 'timer'}`}>
          <div className='PackageItemBlock__details__title-and-icon'>
            <TagName className='PackageItemBlock__details__title-and-icon__title' tagName={data.titleHeadlineTag?.value} isTitle>
              {data.title.value}
            </TagName>

            {data.packageItemStrip.value || data.packageItemStrip.value === 0 ? (
              data.packageItemStrip.value === 0 ? (
                data.circularIconText.value && (
                  <CircularBadge className='PackageItemBlock__details__title-and-icon__circular-badge'>
                    {data.circularIconText.value}
                  </CircularBadge>
                )
              ) : (
                <StripBadge className='PackageItemBlock__details__title-and-icon__strip-badge'>{data.circularIconText.value}</StripBadge>
              )
            ) : data.expireDate.value ? (
              <Timer className='PackageItemBlock__details__title-and-icon__expire-date' expireDate={new Date(data.expireDate.value)} />
            ) : null}
          </div>

          <div className='PackageItemBlock__details__price'> {data.description.value}</div>

          <div className='PackageItemBlock__details__package-features'>
            {data.packageIncludes.expandedValue?.map(({highlightText, text}: MarketingTextBlockData, i) => (
              <div className='PackageItemBlock__details__package-features__feature' key={i}>
                <span className='PackageItemBlock__details__package-features__feature__label'>
                  {text.value.replace(highlightText.value, '').trim()}
                </span>
                <span className='PackageItemBlock__details__package-features__feature__value'>{highlightText.value}</span>
              </div>
            ))}
            {data.icons.expandedValue?.map((icon: IconBlockData, i) => (
              <div className='PackageItemBlock__details__package-features__icon-and-package' key={i}>
                <Image
                  className='PackageItemBlock__details__package-features__icon-and-package__icon'
                  {...getImageProps(icon.image, context)}
                />
                <span className='PackageItemBlock__details__package-features__icon-and-package__name'>{icon.description.value}</span>
              </div>
            ))}
          </div>

          <div className={`PackageItemBlock__details__prices-and-button ${!(data.price.value && data.price.value > 0) && 'no-price'}`}>
            <div className='PackageItemBlock__details__prices-and-button__prices'>
              {data.price.value && data.price.value > 0 ? (
                <>
                  <span className='PackageItemBlock__details__prices-and-button__prices__prePrice'>{data.prePriceText.value}</span>

                  <span
                    className={`PackageItemBlock__details__prices-and-button__prices__price ${
                      data.price.value.toString().includes('.') && `with-comma`
                    }`}>
                    <span className='PackageItemBlock__details__prices-and-button__prices__price__ils'>₪</span>
                    <span
                      className={`PackageItemBlock__details__prices-and-button__prices__price__value  ${
                        data.price.value.toString().includes('.') && `with-comma__price-and-comma`
                      }`}>
                      {checkIfComma(data.price.value.toString())}
                    </span>
                  </span>

                  <span className='PackageItemBlock__details__prices-and-button__prices__month'>לחודש</span>
                </>
              ) : null}

              {data.fullPrice.value > 0 && data.fullPrice.value ? (
                <div className='PackageItemBlock__details__prices-and-button__prices__full-price'>₪{data.fullPrice.value}</div>
              ) : null}
            </div>

            <div className='PackageItemBlock__details__prices-and-button__button'>
              {data.buttonLinkTitle.value || 'לרכישה'} <Image src={require('./images/icons.svg')} />
            </div>
          </div>
        </div>
      </a>

      <div className='PackageItemBlock__bottom-bar'>
        <a className='PackageItemBlock__bottom-bar__link' href={data.packageTermsUrl.value}>
          {data.packageTermsUrlTitle.value} <Arrow />
        </a>
      </div>
    </div>
  );
};

export default PackageItemBlock;
